@if (readonlyAttachmentsPanel == false) {
  <div class="mt-3">
    <div class="card position-relative">
      <div class="card-header bg-light">OTHER DOCUMENTS</div>
      <div class="card-body text-center">
        <!-- Loader component -->
        @if (isLoading) {
          <loader [config]="loaderConfig"></loader>
        }
        @if (!files.length) {
          <div class="no-files-message">
            <p class="text-muted text-center">No files attached yet.</p>
          </div>
        }
        @if (files.length) {
          <div class="file-list-container">
            @for (file of files; track file) {
              <div class="card mb-2">
                <div class="card-body d-flex justify-content-between align-items-center py-2">
                  <div class="file-info">
                    <i class="fa fa-file me-2 text-primary"></i>
                    <span>{{ file.fileNameOriginal }}</span>
                  </div>
                  <div class="file-actions">
                    <button class="btn btn-outline-secondary btn-sm me-2" (click)="viewFile(file)" title="View file">
                      <i class="fa fa-solid fa-eye"></i>
                    </button>
                    @if (readonlyAttachmentsPanel == false) {
                      <button class="btn btn-outline-danger btn-sm" (click)="confirmDelete(file)" title="Delete file">
                        <i class="fa fa-solid fa-trash"></i>
                      </button>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
        <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;"/>
        <button class="btn btn-primary" [disabled]="customer === undefined || customer === null" (click)="fileInput.click()">
          <i class="fa fa-solid fa-plus me-1"></i> Add another file
        </button>
        @if (uploadStatus) {
          <div class="mt-2 text-center">
            <small [ngClass]="{'text-success': uploadStatus.success, 'text-danger': !uploadStatus.success}">
              {{uploadStatus.message}}
            </small>
          </div>
        }
      </div>
    </div>
  </div>
}